import React from 'react';
import PropTypes from 'prop-types';
import { GridListToggle } from 'web-ui-components/lib/layout/content';

import NBABL from '../nba/NBABL';
import HeroCard from '../nba/HeroCard';
import { homepageAdvertsList } from './HomepageAdvertsList';
import ActivateHardTokenTile from './ActivateHardTokenTile';
import HomepageTiles from './HomepageTiles';
import HomepageTilesAccountsList from './HomepageTilesAccountsList';
import homepageNonAccountTiles from './HomepageNonAccountTiles';

const HomepageViewPreferenceIsList = 'HomepageViewPreferenceIsList';

class HomepageAccounts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isListViewSelected: false,
    };
  }

  componentWillMount() {
    let preferredViewTypeIsList;

    if (window.localStorage) {
      preferredViewTypeIsList = localStorage.getItem(
        HomepageViewPreferenceIsList
      );
    }

    this.setState({ isListViewSelected: preferredViewTypeIsList === 'true' });
  }

  componentWillUnmount() {
    if (window.localStorage) {
      localStorage.setItem(
        HomepageViewPreferenceIsList,
        this.state.isListViewSelected
      );
    }
  }

  render() {
    const { isSMEUser, isLCV } = this.props;
    const { isListViewSelected } = this.state;
    const renderList = isSMEUser && isListViewSelected;

    if (isLCV || !isSMEUser) {
      return this.renderTiles();
    }

    return (
      <span>
        <section className="sme-grid-view-toggle__container">
          <GridListToggle
            name="homepage-account-toggle-list-view"
            data-test-id="homepage-account-toggle-list-view"
            onChange={() =>
              this.setState((prevState) => ({
                isListViewSelected: !prevState.isListViewSelected,
              }))
            }
            isListViewSelected={isListViewSelected}
          />
        </section>
        {renderList ? this.renderList() : this.renderTiles()}
      </span>
    );
  }

  renderTiles() {
    const {
      includeAccounts,
      accounts,
      content,
      className,
      nbaData,
      invokeModal,
      advertClick,
      goToAccountDetails,
      shouldActivateHardToken,
      handleActivateTokenClick,
      messageCount,
    } = this.props;

    return (
      <HomepageTiles
        includeAccounts={includeAccounts}
        accounts={accounts}
        content={content}
        className={className}
        invokeModal={invokeModal}
        nbaData={nbaData}
        advertClick={advertClick}
        goToAccountDetails={goToAccountDetails}
        shouldActivateHardToken={shouldActivateHardToken}
        handleActivateTokenClick={handleActivateTokenClick}
        messageCount={messageCount}
      />
    );
  }

  renderList() {
    const {
      accounts,
      content,
      nbaData,
      invokeModal,
      advertClick,
      goToAccountDetails,
      shouldActivateHardToken,
      handleActivateTokenClick,
      messageCount,
    } = this.props;

    return (
      <section className="sme-lcv-layout">
        <div className="sme-lcv-layout-column1">
          {HomepageTilesAccountsList({
            accounts,
            goToAccountDetails,
            content,
            updates: nbaData.getUpdates(),
            products: nbaData.getProducts(),
            invokeModal,
          })}
        </div>
        <div className="sme-lcv-layout-column2 sme-account-list">
          {homepageNonAccountTiles({
            updates: nbaData.getUpdates(),
            products: nbaData.getProducts(),
            invokeModal,
          })}
          {shouldActivateHardToken && (
            <ActivateHardTokenTile
              content={content}
              onClick={handleActivateTokenClick}
            />
          )}
          {homepageAdvertsList({ advertClick, messageCount, content })}
          {NBABL.getBannerComponent(
            <HeroCard data={nbaData.getHeros()} action={invokeModal} />
          )}
          {NBABL.getBannerComponent(
            <HeroCard data={nbaData.getBanners()} action={invokeModal} />
          )}
        </div>
      </section>
    );
  }
}

HomepageAccounts.propTypes = {
  includeAccounts: PropTypes.bool.isRequired,
  accounts: PropTypes.array.isRequired,
  content: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  nbaData: PropTypes.object.isRequired,
  invokeModal: PropTypes.func.isRequired,
  advertClick: PropTypes.func.isRequired,
  goToAccountDetails: PropTypes.func.isRequired,
  shouldActivateHardToken: PropTypes.bool.isRequired,
  handleActivateTokenClick: PropTypes.func.isRequired,
  isSMEUser: PropTypes.bool.isRequired,
  isLCV: PropTypes.bool.isRequired,
  count: PropTypes.number,
};

export default HomepageAccounts;
